import { v4 } from 'uuid';

import {
  DEFAULT_PRICE_TYPE,
  type FxTargetAccumulator,
  type TargetAccumulatorProperties,
  type TargetAccuType,
} from '@/store/targetAccumulator/state.ts';

export const initTargetAccumulator: (clientId?: number, currencyPair?: string) => FxTargetAccumulator = (
  clientId?: number,
) =>
  ({
    type: 'FxTargetAccumulator',
    clientId,
    properties: {
      hedgeType: 'Live',
      isPriceable: false,
      rfsVersion: 0,
      rfs: {
        status: 'CANCELLED',
      },
      notionalCurrencyIndex: 1,
      premiumPriceType: DEFAULT_PRICE_TYPE,
      premiumTypeCurrencyIndex: 1,
      amountMode: 'Fixing',
      clientsWay: 'Buy',
      leverage: 2,
      hedgeAmount: null,
      hedgePaymentDate: null,
      marginCurrency: '',
      notional: null,
      premiumDate: null,
      premiumDateTenor: null,
      settlementModeList: [],
      possibleHedgeTypes: [],
      mifid: { records: [] },

      hedgeCurrencyIndex: 1,
      summary: '',
      settlementMode: 'Physical_Spot',
      accuType: 'TargetAccu',
      targetProfitType: 'NONE',

      uiState: { displayMode: 'Pricer' },
    },
    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  }) satisfies FxTargetAccumulator;

export const generateEmptyTargetAccumulator: (
  props?: Partial<TargetAccumulatorProperties>,
  clientId?: number,
) => FxTargetAccumulator = (props?: Partial<TargetAccumulatorProperties>, clientId?: number) =>
  ({
    type: 'FxTargetAccumulator',
    clientId,
    properties: {
      hedgeType: 'Live',
      isPriceable: false,
      rfsVersion: 0,
      rfs: {
        status: 'CANCELLED',
      },
      notionalCurrencyIndex: 1,
      premiumPriceType: DEFAULT_PRICE_TYPE,
      premiumTypeCurrencyIndex: 1,
      amountMode: 'Fixing',
      clientsWay: 'Buy',
      leverage: 2,
      hedgeAmount: null,
      hedgePaymentDate: null,
      mifid: { records: [] },

      marginCurrency: '',
      notional: null,
      premiumDate: null,
      premiumDateTenor: null,
      settlementModeList: [],
      possibleHedgeTypes: [],

      hedgeCurrencyIndex: 1,
      summary: '',
      settlementMode: 'Physical_Spot',
      accuType: 'TargetAccu',
      targetProfitType: 'NONE',

      uiState: { displayMode: 'Pricer' },

      ...props,
    },
    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  }) satisfies FxTargetAccumulator;

export function getTargetAccumulatorCalendarColumns(
  accumulatorType: TargetAccuType,
): Array<Partial<SchedulerCalendarProperty>> {
  switch (accumulatorType) {
    case 'EKI':
      return ['fixingDate', 'paymentDate', 'EKI', 'strike', 'amount', 'leverageAmount', 'deleteIcon'];
    case 'PIVOT':
      return ['fixingDate', 'paymentDate', 'strikeUp', 'PIVOT', 'strikeDown', 'amount', 'leverageAmount', 'deleteIcon'];
    case 'PIVOTEKI':
      return [
        'fixingDate',
        'paymentDate',
        'ekiUp',
        'strikeUp',
        'PIVOT',
        'strikeDown',
        'ekiDown',
        'amount',
        'leverageAmount',
        'deleteIcon',
      ];

    default:
      return ['fixingDate', 'paymentDate', 'strike', 'amount', 'leverageAmount', 'deleteIcon'];
  }
}

export const calendarProperties = [
  'fixingDate',
  'paymentDate',
  'EKI',
  'strike',
  'ekiUp',
  'strikeUp',
  'PIVOT',
  'strikeDown',
  'ekiDown',
  'amount',
  'leverageAmount',
  'deleteIcon',
] as const;

export type SchedulerCalendarProperty = (typeof calendarProperties)[number];
